import React from 'react';

const LogoPoweredByBiologis = () => {
  return (
    <svg
      version="1.1"
      id="Ebene_2"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="283.465px"
      height="283.464px"
      viewBox="0 0 283.465 283.464"
      enableBackground="new 0 0 283.465 283.464"
      xmlSpace="preserve"
      className="logo-powered-by-biologis"
    >
      <g>
        <g>
          <g>
            <path
              fill="#4B6475"
              d="M72.461,161.279c-1.769,0-3.227,0.381-4.383,1.095v-7.67v-0.368h-0.369h-2.221h-0.369v0.368V178.5v0.236
                                l0.214,0.097c2.021,0.919,5.118,1.403,7.128,1.403c5.978,0,8.199-2.556,8.199-9.428C80.66,163.951,78.36,161.279,72.461,161.279z
                                 M72.461,177.381c-1.605,0-3.173-0.231-4.383-0.625v-10.565c0-1.413,2.272-2.06,4.383-2.06c3.525,0,5,0.925,5,6.644
                                C77.461,176.47,76.274,177.381,72.461,177.381z"
            />
            <polygon
              fill="#4B6475"
              points="86.752,161.757 86.384,161.757 86.384,162.123 86.384,179.391 86.384,179.756 86.752,179.756
                                88.975,179.756 89.342,179.756 89.342,179.391 89.342,162.123 89.342,161.757 88.975,161.757                       "
            />
            <path
              fill="#4B6475"
              d="M103.267,161.279c-5.902,0-8.201,2.635-8.201,9.394c0,6.882,2.299,9.564,8.201,9.564
                                c5.92,0,8.232-2.682,8.232-9.564C111.5,163.825,109.27,161.279,103.267,161.279z M103.267,177.45
                                c-3.527,0-4.999-0.93-4.999-6.706c0-5.71,1.248-6.68,4.999-6.68c3.836,0,5.032,0.919,5.032,6.68
                                C108.299,176.52,106.816,177.45,103.267,177.45z"
            />
            <path
              fill="#4B6475"
              d="M135.088,174.946v-20.242v-0.368h-0.368h-2.223h-0.368v0.368v20.378c0,2.648,0.762,3.859,2.268,5.291
                                l0.237,0.229l0.255-0.21l1.708-1.437l0.306-0.258l-0.281-0.286C135.404,177.192,135.088,176.483,135.088,174.946z"
            />
            <path
              fill="#4B6475"
              d="M149.181,161.279c-5.903,0-8.196,2.635-8.196,9.394c0,6.882,2.293,9.564,8.196,9.564
                                c5.927,0,8.233-2.682,8.233-9.564C157.414,163.825,155.183,161.279,149.181,161.279z M149.181,177.45
                                c-3.525,0-4.999-0.93-4.999-6.706c0-5.71,1.25-6.68,4.999-6.68c3.839,0,5.032,0.919,5.032,6.68
                                C154.212,176.52,152.728,177.45,149.181,177.45z"
            />
            <path
              fill="#4B6475"
              d="M170.89,161.279c-5.896,0-8.197,2.635-8.197,9.394c0,6.882,2.3,9.564,8.197,9.564
                                c1.737,0,3.188-0.389,4.362-1.114c-0.231,3.906-2.458,4.72-5.935,4.72c-0.864,0-2.212-0.187-3.336-0.473
                                c-0.03-0.008-0.064-0.013-0.091-0.021l-0.828,2.787c0.047,0.013,0.2,0.042,0.246,0.052c1.367,0.308,2.981,0.51,4.009,0.51
                                c6.253,0,8.917-2.561,8.917-8.571V163.01v-0.234l-0.217-0.1C175.997,161.757,172.904,161.279,170.89,161.279z M170.89,164.132
                                c1.603,0,3.176,0.231,4.385,0.625v10.528c0,1.439-2.27,2.096-4.385,2.096c-3.522,0-4.998-0.922-4.998-6.638
                                C165.892,165.043,167.076,164.132,170.89,164.132z"
            />
            <polygon
              fill="#4B6475"
              points="184.771,161.757 184.406,161.757 184.406,162.123 184.406,179.391 184.406,179.756
                                184.771,179.756 186.998,179.756 187.364,179.756 187.364,179.391 187.364,162.123 187.364,161.757 186.998,161.757                "
            />
            <path
              fill="#4B6475"
              d="M200.111,169.11c-3.3-0.221-3.961-1.045-3.961-2.301c0-2.327,1.058-2.745,4.044-2.745
                                c1.5,0,3.291,0.352,4.786,0.936l0.352,0.139l0.128-0.36l0.753-2.123l0.131-0.371l-0.382-0.105
                                c-2.075-0.583-4.122-0.901-5.769-0.901c-5.054,0-7.209,1.715-7.209,5.731c0,3.94,3.27,4.726,6.803,4.986
                                c3.295,0.271,3.897,1.101,3.897,2.64c0,2.451-1.143,2.847-3.874,2.847c-1.747,0-4.267-0.452-5.382-0.958l-0.372-0.171
                                l-0.13,0.389l-0.688,2.088l-0.113,0.347l0.346,0.116c1.738,0.591,4.592,0.943,6.339,0.943c4.998,0,7.04-1.681,7.04-5.805
                                C206.852,171.022,204.836,169.433,200.111,169.11z"
            />
          </g>
          <path
            fill="#4B6475"
            d="M121.728,167.269c-1.612,0-2.923,1.311-2.923,2.918c0,1.613,1.311,2.924,2.923,2.924
                        c1.609,0,2.92-1.311,2.92-2.924C124.648,168.579,123.337,167.269,121.728,167.269z"
          />
        </g>
        <path
          fill="#8C9FAE"
          d="M181.388,112.311c-6.308-0.447-12.825-3.312-19.152-2.656c-6.651,0.691-9.632,11.766-12.165,16.625
                c-4.185,8.027-11.344,11.143-19.856,7.494c-2.753-1.182-5.143-3.06-7.543-4.82c-1.667-1.216-4.388-2.637-5.879-4.308l-0.4-0.034
                c0.011,0.016,0.021,0.037,0.034,0.05c2.103,3.152,6.049,5.235,9.039,7.45c7.124,5.282,16.062,8.077,22.826,0.693
                c5.319-5.811,5.836-15.7,12.158-20.699c3.957-3.128,18.515,1.096,21.706,0.675C182.5,112.676,182.15,112.379,181.388,112.311z"
        />
        <g>
          <path
            fill="#8C9FAE"
            d="M160.828,141.568c-3.409,0-8.823-1.849-16.997-5.708l0.181-0.375c12.153,5.729,18.237,7.008,20.341,4.274
                        c0.312-0.402,0.399-0.935,0.278-1.592c-0.584-3.037-5.769-8.217-11.804-11.797l0.216-0.36c6.225,3.698,11.383,8.889,11.996,12.075
                        c0.153,0.78,0.032,1.432-0.355,1.931C163.892,141.042,162.644,141.568,160.828,141.568z"
          />
        </g>
        <g>
          <g>
            <path
              fill="#8C9FAE"
              d="M124.376,128.045c-2.33-6.585-2.169-13.541,0.446-19.58c5.894-13.585,20.972-20.171,33.618-14.689
                                l0.293,0.134c3.275,3.575,4.588,7.66,4.393,13.662l-0.419-0.013c0.191-5.863-1.082-9.853-4.246-13.331l-0.179-0.066
                                c-12.444-5.396-27.276,1.098-33.073,14.468c-2.574,5.942-2.731,12.792-0.438,19.278L124.376,128.045z"
            />
          </g>
          <g>
            <path
              fill="#8C9FAE"
              d="M166.92,103.587c-3.196,0-8.608-1.516-11.266-2.818c-5-2.456-9.655-5.839-8.777-7.865
                                c0.32-0.73,1.217-1.019,2.707-1.019l-0.003,0.36c-1.319,0.008-2.078,0.268-2.318,0.825c-0.646,1.487,2.962,4.565,8.578,7.321
                                c3.69,1.812,11.854,3.707,13.08,2.317l0.315,0.273C168.864,103.409,168.023,103.587,166.92,103.587z"
            />
          </g>
          <g>
            <path
              fill="#8C9FAE"
              d="M135.574,107.822l-0.372-0.194c4.407-8.24,15.917-15.059,23.238-13.754l0.15,0.441
                                C151.262,92.965,139.906,99.718,135.574,107.822z"
            />
          </g>
        </g>
        <path
          fill="#8C9FAE"
          d="M132.285,110.478c-0.961-1.773-0.297-3.974,1.466-4.931c1.771-0.951,3.981-0.292,4.93,1.477
                c0.963,1.765,0.297,3.974-1.469,4.93C135.44,112.907,133.227,112.248,132.285,110.478z"
        />
        <path
          fill="#8C9FAE"
          d="M158.358,134.203c0.579,1.71,2.435,2.619,4.135,2.036c1.691-0.583,2.605-2.43,2.026-4.132
                c-0.578-1.705-2.432-2.608-4.135-2.031C158.69,130.654,157.779,132.503,158.358,134.203"
        />
        <path
          fill="#8C9FAE"
          d="M167.435,103.627c-0.621-1.413,0.032-3.058,1.438-3.675c1.411-0.612,3.048,0.034,3.673,1.442
                c0.612,1.405-0.032,3.055-1.44,3.665C169.692,105.678,168.049,105.035,167.435,103.627"
        />
        <path
          fill="#F5D410"
          d="M159.1,112.429c-0.836-1.92,0.045-4.156,1.957-4.994c1.924-0.835,4.154,0.04,4.995,1.957
                c0.844,1.92-0.035,4.158-1.965,4.996C162.172,115.229,159.937,114.347,159.1,112.429"
        />
        <path
          fill="#6AA842"
          d="M145.929,140.378c3.008-1.308,4.377-4.802,3.061-7.807c-1.313-3.005-4.809-4.376-7.805-3.063
                c-2.999,1.311-4.375,4.802-3.07,7.807C139.431,140.32,142.926,141.691,145.929,140.378"
        />
        <g>
          <path
            fill="#8C9FAE"
            d="M113.125,142.249c6.757,0.591,10.767-4.174,12.929-10.016c1.437-3.882,2.402-8.043,4.917-11.426
                        c4.896-6.593,15.363,3.281,20.277,4.82c6.034,1.889,13.819,3.796,19.667,0.51c10.436-5.871-1.081-19.961,9.312-26.549
                        c1.22-0.775-0.809,0.2-1.133,0.404c-3.709,2.354-5.703,5.106-5.952,9.591c-0.288,5.085,2.175,10.972-1.305,15.406
                        c-2.539,3.242-9.985,1.508-13.268,0.822c-4.886-1.024-9.121-2.774-13.469-5.253c-6.208-3.531-12.473-7.849-17.216,2.86
                        c-2.842,6.417-3.465,18.485-12.821,17.665C114.45,141.032,113.386,142.267,113.125,142.249L113.125,142.249z"
          />
        </g>
        <path
          fill="#C30436"
          d="M121.338,132.895c-0.923-2.104,0.05-4.555,2.142-5.474c2.102-0.909,4.541,0.052,5.469,2.151
                c0.92,2.099-0.045,4.547-2.143,5.464C124.704,135.955,122.253,134.996,121.338,132.895"
        />
        <path
          fill="#007AC0"
          d="M147.989,126.275c-0.923-2.123,0.043-4.61,2.175-5.537c2.137-0.935,4.619,0.04,5.549,2.175
                c0.924,2.13-0.041,4.615-2.181,5.542C151.404,129.388,148.923,128.418,147.989,126.275"
        />
        <g>
          <path
            fill="#8C9FAE"
            d="M144.518,144.733l0.114-0.365c5.49-0.076,12.958-3.777,16.618-10.696l0.369,0.194
                        C157.884,140.935,150.173,144.762,144.518,144.733z"
          />
        </g>
        <g>
          <path
            fill="#8C9FAE"
            d="M144.449,144.318c7.228,1.174,14.258-0.268,19.295-3.948l0.244,0.336
                        c-3.954,2.895-9.124,4.431-14.65,4.431c-1.563,0-3.374-0.152-4.968-0.399L144.449,144.318z"
          />
        </g>
        <g>
          <path
            fill="#8C9FAE"
            d="M175.576,118.447h-0.42c0-6.401-2.346-12.548-6.612-17.311l0.309-0.281
                        C173.188,105.699,175.576,111.943,175.576,118.447z"
          />
        </g>
      </g>
    </svg>
  );
};

export default LogoPoweredByBiologis;
